export default __webpack_public_path__ + "static/media/Error.7d51b700.svg";